// FILE: src/Comman Components/Pinterest Componets/PinName.js (FULLY UPDATED)
import React from 'react';
import { useSelector } from 'react-redux';

const getResolvedPinterestName = (profileDetails = {}) => {
  return (
    profileDetails.name ||
    profileDetails.business_name ||
    profileDetails.username ||
    profileDetails.profile ||
    '...'
  );
};

export default function PinName({ Id }) {
  const profileDetails = useSelector((state) => state.groups.profileDetails[Id]);

  if (!Id) return <span className='font-bold text-red-500'>Unknown User</span>;
  if (!profileDetails) return <span className='font-bold'>Loading...</span>;

  if (profileDetails.error) {
    return (
      <span className='font-bold text-yellow-600'>
        {getResolvedPinterestName(profileDetails)}
      </span>
    );
  }

  return <span className='font-bold'>{getResolvedPinterestName(profileDetails)}</span>;
}